<script setup lang="ts">
import { computed } from "vue";
export interface TabOption { value: string; label: string }

const props = withDefaults(
  defineProps<{ modelValue?: string; options?: (string | TabOption)[] }>(),
  { options: () => [] },
);
defineEmits<{ "update:modelValue": [string] }>();

const normalised = computed<TabOption[]>(() =>
  props.options.map((o) => (typeof o === "string" ? { value: o, label: o } : o)),
);
</script>
<template>
  <div
    class="cw-tabs"
    role="tablist"
  >
    <button
      v-for="opt in normalised"
      :key="opt.value"
      type="button"
      role="tab"
      :aria-selected="opt.value === modelValue"
      class="cw-tabs__item"
      :class="{ 'cw-tabs__item--active': opt.value === modelValue }"
      @click="$emit('update:modelValue', opt.value)"
    >
      {{ opt.label }}
    </button>
  </div>
</template>
